// frontend/src/context/AuthContext.js
import React, { createContext, useState, useEffect, useMemo } from 'react';
import axios from 'axios';

const API_BASE_URL = ``;

// Создаем контекст
export const AuthContext = createContext();

// Создаем провайдер контекста
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('accessToken'));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Для отслеживания загрузки данных пользователя

  // Функция для входа (устанавливает токен)
  const login = (accessToken) => {
    localStorage.setItem('accessToken', accessToken);
    setToken(accessToken);
  };

  // Функция для выхода (удаляет токен и данные пользователя)
  const logout = () => {
    localStorage.removeItem('accessToken');
    setToken(null);
    setUser(null);
  };

  // Функция для получения данных текущего пользователя
  const fetchCurrentUser = async () => {
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/users/me/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(response.data);
    } catch (err) {
      console.error('Ошибка при получении данных пользователя:', err);
      // Если токен недействителен, выходим
      if (err.response?.status === 401) {
        logout();
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // Эффект для загрузки данных пользователя при изменении токена
  useEffect(() => {
    fetchCurrentUser();
  }, [token]);

  // Эффект для настройки axios interceptor
  useEffect(() => {
    // Интерцептор для добавления токена к каждому запросу
    const requestInterceptor = axios.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Интерцептор для обработки 401 Unauthorized
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          // Токен истёк или недействителен
          console.warn('Токен истёк или недействителен. Выход из системы.');
          logout();
        }
        return Promise.reject(error);
      }
    );

    // Убираем интерцепторы при размонтировании
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [token]);

  // Значение контекста
  const value = useMemo(
    () => ({
      token,
      user,
      login,
      logout,
      loading,
    }),
    [token, user, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
